<template>
    <chart :options="opt" />
</template>

<script>
  import ECharts from "vue-echarts";
  import ecStat from "echarts-stat";
  import "echarts/lib/chart/bar";
  import data from "../data/a1";

  export default {
    name: "a1",
    props: {},
    components: { chart: ECharts, ecStat },
    data() {
      return {
        data: [],
        fData: { nameArr: [], valArr: [] },
        medianValue: 0,
        opt: {}
      };
    },
    mounted() {
      this.getData();
    },
    created() {

    },
    watch: {},
    methods: {
      getData() {
        this.data = data;
        this.formatterData();
      },
      formatterData() {
        let obj = { nameArr: [], valArr: [] };
        let arr = [];
        // 对数据进行排序
        this.data.sort(this.arrMinToMaxSort("value"));

        this.data.map(item => {
          arr.push(item.value);
        });
        // 计算中位数
        this.getMedianValue(arr);
        this.insertMedianObj();

        this.data.map(item => {
          obj.nameArr.push(item.name);
          obj.valArr.push(item.value);
        });

        this.fData = obj;
        this.showChart();
      },
      insertMedianObj() {
        const dataLen = this.data.length;
        let index = "";
        if(dataLen % 2 === 0) index = dataLen / 2;
        else index = Math.floor(dataLen / 2);
        this.data.splice(index, 0, { name: "中位数", value: this.medianValue });
      },
      arrMinToMaxSort(propertyName) {
        return function(object1, object2) {
          var value1 = object1[propertyName];
          var value2 = object2[propertyName];
          if(value2 < value1) {
            return 1;
          } else if(value2 > value1) {
            return -1;
          } else {
            return 0;
          }
        };
      },
      getMedianValue(data) {
        this.medianValue = ecStat.statistics.median(data);
      },
      showChart() {
        const { nameArr, valArr } = this.fData;
        console.log(nameArr, valArr);
        this.opt = {
          color: ["#3398DB"],
          title: {
            text: ""
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow"
            },
            formatter: "{b} <br> 合格率: {c}%"
          },
          grid: {
            left: "4%",
            right: "4%",
            bottom: "2%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              show: false,
              formatter: "{value}%",
              textStyle: {
                fontWeight: "80"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          yAxis: {
            type: "category",
            data: nameArr,
            axisLabel: {
              show: true,
              interval: 0,
              rotate: 0,
              margin: 10,
              inside: false,
              textStyle: {
                fontWeight: "50"
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            }
          },
          series: [
            {
              type: "bar",
              label: {
                show: true,
                formatter: function(v) {
                  var val = v.data;
                  return val + "%";
                },
                color: "#000",
                position: "right"
              },
              itemStyle: {
                color: function(params) {
                  var colorList = [
                    "#9BCA63", "#9BCA63", "#9BCA63", "#9BCA63", "#9BCA63",
                    "#F3A43B",
                    "#C1232B", "#C1232B", "#C1232B", "#C1232B", "#C1232B"
                  ];
                  return colorList[params.dataIndex];
                },
              },
              data: valArr
            }]
        };
      }
    }
  };
</script>
<style scoped>

</style>
